import router from '@/router'

const app = {
	state: {
		reloadEvent: {}
	},
	mutations: {
		SET_RELOAD_EVENT: (state, { key, listener }) => {
			state.reloadEvent[key] = listener
		}
	},
	actions: {
		addReloadEvent ({ commit }, listener) {
			const key = window.btoa(router.app._route.fullPath)

			commit('SET_RELOAD_EVENT', { key: key, listener: listener })
		},
		fireReloadEvent ({ state }) {
			const key = window.btoa(router.app._route.fullPath)

			if (state.reloadEvent[key]) {
				state.reloadEvent[key]()
			}
		}
	}
}

export default app


// WEBPACK FOOTER //
// ./src/store/modules/app.js